import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Database, Search, Link as LinkIcon, TestTube } from 'lucide-react';

export default function RncpMain() {
  const navigate = useNavigate();
  const location = useLocation();

  // Déterminer l'onglet actif basé sur l'URL
  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes('listing-formation')) return 'listing';
    if (path.includes('rncp-search')) return 'search';
    if (path.includes('rncp-mapping')) return 'mapping';
    if (path.includes('rncp-test')) return 'test';
    return 'listing';
  };

  const [activeTab, setActiveTab] = useState(getActiveTab());

  const tabs = [
    {
      id: 'listing',
      name: 'Listing Formation',
      icon: Database,
      path: '/listing-formation',
      description: 'Gérer les formations'
    },
    {
      id: 'search',
      name: 'Recherche',
      icon: Search,
      path: '/rncp-search',
      description: 'Rechercher des certifications'
    },
    {
      id: 'mapping',
      name: 'Mapping RNCP/ROME',
      icon: LinkIcon,
      path: '/rncp-mapping',
      description: 'Correspondances RNCP/ROME'
    },
    {
      id: 'test',
      name: 'Tests',
      icon: TestTube,
      path: '/rncp-test',
      description: 'Tests et vérifications'
    }
  ];

  const handleTabClick = (tab) => {
    setActiveTab(tab.id);
    navigate(tab.path);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Gestion RNCP
          </h1>
          <p className="text-gray-600">
            Gérer les certifications RNCP et leurs correspondances ROME
          </p>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-0">
            {tabs.map((tab, index) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;

              return (
                <button
                  key={tab.id}
                  onClick={() => handleTabClick(tab)}
                  className={`
                    relative p-6 text-left transition-all
                    ${index !== tabs.length - 1 ? 'border-r border-gray-200' : ''}
                    ${isActive
                      ? 'bg-blue-50 border-b-4 border-b-blue-600'
                      : 'hover:bg-gray-50 border-b-4 border-b-transparent'
                    }
                  `}
                >
                  <div className="flex items-start space-x-3">
                    <Icon className={`w-6 h-6 mt-0.5 ${isActive ? 'text-blue-600' : 'text-gray-400'}`} />
                    <div className="flex-1 min-w-0">
                      <h3 className={`text-sm font-semibold mb-1 ${isActive ? 'text-blue-900' : 'text-gray-900'}`}>
                        {tab.name}
                      </h3>
                      <p className={`text-xs ${isActive ? 'text-blue-700' : 'text-gray-500'}`}>
                        {tab.description}
                      </p>
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        </div>

        {/* Instructions */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <p className="text-sm text-blue-800">
            💡 <strong>Navigation :</strong> Utilisez les onglets ci-dessus pour accéder aux différentes fonctionnalités RNCP
          </p>
        </div>
      </div>
    </div>
  );
}
